import {Typography} from '@mui/material';
import React from 'react';
import {observer} from 'mobx-react';
import Box from '../../Common/Box';
import Paper from '../../Common/Paper';
import shadowConfig from '../../config';

export default observer(function AppInfo() {

    return <Box
            style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                maxWidth: "600px",
                maxHeight: "100%",
                pointerEvents: "all",
                overflow: "auto",
                marginBottom: "10px",
            }}
    >
        <Paper
                sx={{
                    position: "relative"
                }}
                elevation={2}
                column
                margin={"14px 14px 0 14px"}
                padding={"8px 6px 12px 12px"}
        >
            <Typography variant={"overline"}>{"App version"}</Typography>
            {shadowConfig.appVersion}
            <Typography variant={"overline"}>{"App env"}</Typography>
            {shadowConfig.appEnv}
            <Typography variant={"overline"}>{"Last commit message"}</Typography>
            {shadowConfig.lastCommitMessage}
        </Paper>
    </Box>
});
